import { useState } from "react"

import { SetCurrentScreen } from "../../../../components/account/providers/firstLoginProvider"
import { MFA } from "../../../../components/account/screenDispatchers/firstLoginConstants"
import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { postClientProtected } from "../../clients/clients"
import { CREATE_ORG } from "../../urls/private"

interface ICreateOrg {
    isCreating: boolean
    error: IAppError | undefined
    postCreateOrg: (
        orgName: string,
        address: string,
        postcode: string,
        orgPhone: string,
        orgType: string,
        setCurrentScreen: SetCurrentScreen
    ) => Promise<void>
}

/**
 * Hook for creating an organisation - called from the create organisation form
 * when a user initially logs in for the first time.
 * @returns {ICreateOrg} - loading and error states.
 */
const useCreateOrg = (): ICreateOrg => {
    const [isCreating, setIsCreating] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postCreateOrg = async (
        orgName: string,
        address: string,
        postcode: string,
        orgPhone: string,
        orgType: string,
        setCurrentScreen: SetCurrentScreen
    ): Promise<void> => {
        try {
            setIsCreating(true)

            const body = {
                org_name: orgName,
                org_address: address,
                org_postcode: postcode,
                org_phone_number: orgPhone,
                org_type: orgType,
                new_user_management_option: "add", // Fixed
                invite_existing_users: true, // Fixed
            }

            await postClientProtected(CREATE_ORG, body)
            setCurrentScreen(MFA)
            setError(undefined)
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            setIsCreating(false)
        }
    }

    return {
        error,
        isCreating,
        postCreateOrg,
    }
}

export default useCreateOrg

// TODO - api if I create an org then try again, does API fail
